import { Navigate, useLocation } from 'react-router-dom';
import { Result } from 'antd';
import { useAuth } from '@/lib/auth';
import type { ReactNode } from 'react';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { token, isAdmin } = useAuth();
  const loc = useLocation();
  if (!token) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="Access denied"
        subTitle="Your account is not authorized as an admin."
      />
    );
  }
  return <>{children}</>;
}
